<template>
    <div class="radio__item" :class="{'isBE' : isBE, 'isNCH': isNCH }" >
        <!-- Default input, which is hidden -->
    <input :disabled="available == 0 || exceed == 'yes' || !valid_layout" type="radio" :id="'room_' + id" name="radios" value="" class="b radio__input" @change="setSelectedRoom(id, position)" :checked="isRoomSelected(id)">

        <!-- Content (this needs to be right after radio input for the styles to work properly-->

        <label :for="'room_' + id" class="radio__content">

        <div class="radio__main">

        <!-- Tiny image carousel full screen carousel on click -->

        <div class="tiny-carousel radio__carousel carousel-toggle" :class="{'no-image': checkImage}" @click="openRoomLightBox(0)" :style="{ backgroundImage: `url('${image[0]}')` }">
        </div>
        <div v-if="show360Modal" class="video__container_360" style="height:100%;">
        <ModalComponent v-if="show360Modal" @close="show360Modal = false">
            <div slot="header"></div>
            <div slot="body" class="video360ModalBody">
            <div style="margin:0px;padding:0px;overflow:hidden;height:100%;">
                <iframe :src="threeSixtyView" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:150%;width:150%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="150%" width="150%"></iframe>
            </div>
            </div>
            <div slot="footer">
            <button style="background-color: #0055a9;position:absolute;top:unset!important;bottom:10px;" type="button" title="Close (Esc)" class="modal-default-button vue-lb-button-close threeSixtyCloseBtn" @click="show360Modal = false">
                        <span>
                        <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                            <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"></path>
                        </svg>
                        </span>
            </button>
            </div>
        </ModalComponent>
        </div>

        <!-- Title -->

        <div class="radio__head" :class="{'radio_head__be': isBE, 'radio_head_disabled': (available == 0 || exceed == 'yes' || !valid_layout)}">

            <h2 class="radio__title">{{ title }} <br> <span class="ribbon ribbon--with-icon" 
            v-if="instantBookable == '1' && !(available == 0 || exceed == 'yes' || !valid_layout || notNumericMT || chosenPriceType == 'none')"
            ><img src="../assets/img/icon-flash.svg" alt="" class="ribbon__img"> {{ strings.availableImmediately }}</span></h2>
            <!-- Meta information -->

            <ul class="inline-list inline-list--small radio__meta">
              <li class="inline-list__item">{{ roomMin }}-{{ roomMax }} {{ strings.people }}</li>
            </ul>
                <ul class="boxlist" v-if="currentTab == 'room' && chosenPriceType != 'opera' && !isSmartSpace">
                    <li class="boxlist__item" :class="{'boxlist__chosen-price' : chosenPriceType == 'normal'}" v-if="(roomPriceVat > 0 && !(roomHalfDay > 0 || roomFullDay > 0) ) || chosenPriceType == 'normal'" >
                        <h5 class="boxlist__title" v-if="roomPriceVat > 0"> {{ currencySymbol }} {{ (roomPriceVat / 100).toFixed(2) }} </h5>
                        <h5 class="boxlist__title" v-else>-</h5>
                        <p class="boxlist__description">{{ strings.hour }}</p>
                    </li>
                    <li class="boxlist__item" :class="{'boxlist__chosen-price' : chosenPriceType == 'halfday'}" v-if="roomHalfDay > 0">
                        <h5 class="boxlist__title" v-if="roomHalfDay > 0"> {{ currencySymbol }} {{ (roomHalfDay / 100).toFixed(2) }} </h5>
                        <h5 class="boxlist__title" v-else>-</h5>
                        <p class="boxlist__description">{{ strings.perHalfDay}}</p>
                    </li>
                    <li class="boxlist__item" :class="{'boxlist__chosen-price' : chosenPriceType == 'fullday'}" v-if="roomFullDay > 0">
                        <h5 class="boxlist__title" v-if="roomFullDay > 0"> {{ currencySymbol }} {{ (roomFullDay / 100).toFixed(2) }} </h5>
                        <h5 class="boxlist__title" v-else>-</h5>
                        <p class="boxlist__description">{{ strings.perFullDay }}</p>
                    </li>
                </ul>
                <p v-if="isSmartSpace && currentTab == 'room'" style="font-size:14px;padding-right:5px;">
                    The <b style="color: #dd2c00;">minimum spend</b> to book this room is {{ currencySymbol }} <strong>{{minRevenue.toFixed(2)}}</strong>. You can add food and beverage or services to this booking on the checkout page.
                </p>
                <p v-if="isSmartSpace && currentTab == 'package'" style="font-size:14px;padding-right:5px;">
                    The <b style="color: #dd2c00;">minimum number</b> of delegates to book this room is <strong>{{roomMin}}</strong>. You can add food and beverage or services to this booking on the checkout page.
                </p>
            <a class="radio__link js-radio-open-details threesixtyLink" v-if="threeSixtyView && threeSixtyView != 'null'&& isBE"  @click="show360Modal = true" >{{strings.threeSixtyView}}</a>
            <a  v-if="showDetailsToggle" href="" class="radio__link js-radio-open-details" @click.prevent="toggleDetails()">{{ isHidden ? strings.showdetails : strings.hidedetails }}</a>
              <div v-if="(available == 0 || exceed == 'yes' || !valid_layout) && currentTab == 'package'" style="margin-top:10px;">
                <!-- Tiny image carousel full screen carousel on click -->
                <ul class="checklist roomitemList">
                    <li class="checklist__item-disabled--attention" v-if="exceed == 'yes'">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/> {{ strings.yourattendees}} ({{ this.$store.state.delegates }}) {{ strings.exceedthelimit }} {{ strings.thisroom }} ({{ roomMin}} - {{roomMax}})
                     </li>
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="available == 0 && exceed == 'no'">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/>{{ strings.roomnotavailable }}
                    </li>
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="!valid_layout && exceed == 'no' && available == 0">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/>{{ strings.thisRoomDoesNotHave }}
                    </li>
                </ul>
            </div>
        </div>


        <!-- Seating order -->
        <div class="radio__single-detail new_seating_order" :class="{'new_seating_order_disabled': (available == 0 || exceed == 'yes' || !valid_layout)}" v-show="isBE">
              <h4 class="no-border-bottom" v-show="!no_layout">{{ strings.seatingorder }}</h4>
              <!-- Seating layout in room -->
              <ul class="seating-list" v-if="currentTab == 'room'">
                  <li @click="chooseLayout(403, roomLayout.cocktail)" class="seating-list__item" v-tooltip.top-center="strings.layouts['403']" v-if="layoutEnabled('cocktail')"  :class="{'seating-list__item--not-available' : roomLayout.cocktail == null || isExceeded(roomLayout.cocktail), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['cocktail']}" >
                      <img src="../assets/img/seating-cocktail.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cocktail')}">{{ roomLayoutOriginal.cocktail != null ? roomLayoutOriginal.cocktail : '-' }}</p>
                        <p v-if="isCapacityReduced('cocktail')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cocktail != null ? roomLayout.cocktail : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(405, roomLayout.ushape)" class="seating-list__item" v-tooltip.top-center="strings.layouts['405']" v-if="layoutEnabled('ushape')"  :class="{'seating-list__item--not-available' : roomLayout.ushape == null || isExceeded(roomLayout.ushape), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['ushape']}" >
                      <img src="../assets/img/seating-ushape.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('ushape')}">{{ roomLayoutOriginal.ushape != null ? roomLayoutOriginal.ushape : '-' }}</p>
                        <p v-if="isCapacityReduced('ushape')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.ushape != null ? roomLayout.ushape : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(400, roomLayout.boardroom)" class="seating-list__item" v-tooltip.top-center="strings.layouts['400']" v-if="layoutEnabled('boardroom')"  :class="{'seating-list__item--not-available' : roomLayout.boardroom == null || isExceeded(roomLayout.boardroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['boardroom']}" >
                      <img src="../assets/img/seating-boardroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('boardroom')}">{{ roomLayoutOriginal.boardroom != null ? roomLayoutOriginal.boardroom : '-' }}</p>
                        <p v-if="isCapacityReduced('boardroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.boardroom != null ? roomLayout.boardroom : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(404, roomLayout.theater)" class="seating-list__item" v-tooltip.top-center="strings.layouts['404']" v-if="layoutEnabled('theater')" :class="{'seating-list__item--not-available' : roomLayout.theater == null || isExceeded(roomLayout.theater), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['theater']}" >
                      <img src="../assets/img/seating-theater.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('theater')}">{{ roomLayoutOriginal.theater != null ? roomLayoutOriginal.theater : '-' }}</p>
                        <p v-if="isCapacityReduced('theater')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.theater != null ? roomLayout.theater : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(402,roomLayout.classroom)" class="seating-list__item" v-tooltip.top-center="strings.layouts['402']" v-if="layoutEnabled('classroom')"  :class="{'seating-list__item--not-available' : roomLayout.classroom == null || isExceeded(roomLayout.classroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['classroom']}" >
                      <img src="../assets/img/seating-classroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('classroom')}">{{ roomLayoutOriginal.classroom != null ? roomLayoutOriginal.classroom : '-' }}</p>
                        <p v-if="isCapacityReduced('classroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.classroom != null ? roomLayout.classroom : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(399, roomLayout.banquet)" class="seating-list__item" v-tooltip.top-center="strings.layouts['399']" v-if="layoutEnabled('banquet')" :class="{'seating-list__item--not-available' : roomLayout.banquet == null || isExceeded(roomLayout.banquet), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['banquet']}" >
                      <img src="../assets/img/seating-banquet.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('banquet')}">{{ roomLayoutOriginal.banquet != null ? roomLayoutOriginal.banquet : '-' }}</p>
                        <p v-if="isCapacityReduced('banquet')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.banquet != null ? roomLayout.banquet : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(401,roomLayout.cabaret)" class="seating-list__item" v-tooltip.top-center="strings.layouts['401']" v-if="layoutEnabled('cabaret') && !isNCH" :class="{'seating-list__item--not-available' : roomLayout.cabaret == null || isExceeded(roomLayout.cabaret), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['cabaret']}" >
                      <img src="../assets/img/seating-cabaret.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cabaret')}">{{ roomLayoutOriginal.cabaret != null ? roomLayoutOriginal.cabaret : '-' }}</p>
                        <p v-if="isCapacityReduced('cabaret')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cabaret != null ? roomLayout.cabaret : '-' }}</p>
                      </div>
                  </li>
                  <li @click="chooseLayout(760,roomLayout.island)" class="seating-list__item" v-tooltip.top-center="strings.layouts['760']" v-if="layoutEnabled('island')" :class="{'seating-list__item--not-available' : roomLayout.island == null || isExceeded(roomLayout.island), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['island']}" >
                      <img src="../assets/img/seating-island.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('island')}">{{ roomLayoutOriginal.island != null ? roomLayoutOriginal.island : '-' }}</p>
                        <p v-if="isCapacityReduced('island')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.island != null ? roomLayout.island : '-' }}</p>
                      </div>
                  </li>
              </ul>
              <!-- Seating layout in room in package -->
              <ul class="seating-list" v-else>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['403']"
                    @click="chooseLayout(403, roomLayout.cocktail)" 
                    v-if="layoutEnabled('cocktail')"  
                    :class="{
                        'seating-list__item--not-available' : roomLayout.cocktail == null || isExceeded(roomLayout.cocktail), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['cocktail']
                    }" >
                      <img src="../assets/img/seating-cocktail.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cocktail')}">{{ roomLayoutOriginal.cocktail != null ? roomLayoutOriginal.cocktail : '-' }}</p>
                        <p v-if="isCapacityReduced('cocktail')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cocktail != null ? roomLayout.cocktail : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['405']" 
                    @click="chooseLayout(405, roomLayout.ushape)"
                    v-if="layoutEnabled('ushape')" 
                    :class="{
                        'seating-list__item--not-available' : roomLayout.ushape == null || isExceeded(roomLayout.ushape), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['ushape']
                    }" >
                      <img src="../assets/img/seating-ushape.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('ushape')}">{{ roomLayoutOriginal.ushape != null ? roomLayoutOriginal.ushape : '-' }}</p>
                        <p v-if="isCapacityReduced('ushape')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.ushape != null ? roomLayout.ushape : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['400']" 
                    @click="chooseLayout(400, roomLayout.boardroom)"
                    v-if="layoutEnabled('boardroom')"  
                    :class="{
                        'seating-list__item--not-available' : roomLayout.boardroom == null || isExceeded(roomLayout.boardroom), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['boardroom']
                    }" >
                      <img src="../assets/img/seating-boardroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('boardroom')}">{{ roomLayoutOriginal.boardroom != null ? roomLayoutOriginal.boardroom : '-' }}</p>
                        <p v-if="isCapacityReduced('boardroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.boardroom != null ? roomLayout.boardroom : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['404']" 
                    @click="chooseLayout(404, roomLayout.theater)"
                    v-if="layoutEnabled('theater')" 
                    :class="{
                        'seating-list__item--not-available' : roomLayout.theater == null || isExceeded(roomLayout.theater), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['theater']
                    }" >
                      <img src="../assets/img/seating-theater.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('theater')}">{{ roomLayoutOriginal.theater != null ? roomLayoutOriginal.theater : '-' }}</p>
                        <p v-if="isCapacityReduced('theater')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.theater != null ? roomLayout.theater : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['402']" 
                    @click="chooseLayout(402,roomLayout.classroom)"
                    v-if="layoutEnabled('classroom')" 
                    :class="{
                        'seating-list__item--not-available' : roomLayout.classroom == null || isExceeded(roomLayout.classroom), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['classroom']
                    }" >
                      <img src="../assets/img/seating-classroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('classroom')}">{{ roomLayoutOriginal.classroom != null ? roomLayoutOriginal.classroom : '-' }}</p>
                        <p v-if="isCapacityReduced('classroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.classroom != null ? roomLayout.classroom : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['399']" 
                    @click="chooseLayout(399, roomLayout.banquet)"
                    v-if="layoutEnabled('banquet')" 
                    :class="{
                        'seating-list__item--not-available' : roomLayout.banquet == null || isExceeded(roomLayout.banquet), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['banquet']
                    }" >
                      <img src="../assets/img/seating-banquet.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('banquet')}">{{ roomLayoutOriginal.banquet != null ? roomLayoutOriginal.banquet : '-' }}</p>
                        <p v-if="isCapacityReduced('banquet')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.banquet != null ? roomLayout.banquet : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['401']" 
                    @click="chooseLayout(401,roomLayout.cabaret)"
                    v-if="layoutEnabled('cabaret')" 
                    :class="{
                        'seating-list__item--not-available' : roomLayout.cabaret == null || isExceeded(roomLayout.cabaret), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['cabaret']
                    }" >
                      <img src="../assets/img/seating-cabaret.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cabaret')}">{{ roomLayoutOriginal.cabaret != null ? roomLayoutOriginal.cabaret : '-' }}</p>
                        <p v-if="isCapacityReduced('cabaret')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cabaret != null ? roomLayout.cabaret : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" v-tooltip.top-center="strings.layouts['760']" 
                    @click="chooseLayout(760,roomLayout.island)"
                    v-if="layoutEnabled('island')" 
                    :class="{
                        'seating-list__item--not-available' : roomLayout.island == null || isExceeded(roomLayout.island), 
                        'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['island']
                    }" >
                      <img src="../assets/img/seating-island.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('island')}">{{ roomLayoutOriginal.island != null ? roomLayoutOriginal.island : '-' }}</p>
                        <p v-if="isCapacityReduced('island')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.island != null ? roomLayout.island : '-' }}</p>
                      </div>
                  </li>
              </ul>
          </div>


        <!-- Pricing -->

        <div class="radio__pricing" :class="{'radio__pricing_disabled': (available == 0 || exceed == 'yes' || !valid_layout)}" v-if="currentTab == 'room'" >
            <h3 class="radio__price original_price" v-if="hasReducedPrice"> {{ !isEnquiry ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck((roomPriceOriginal * (chosenPriceType == 'normal' ? parseInt(meetingLength): 1) / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck((roomPriceOriginal * (chosenPriceType == 'normal' ? parseInt(meetingLength): 1) / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price savings" v-if="hasReducedPrice" >{{enquiryPriceCheck(displayDiscountAmount)}}</h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}" v-if="chosenPriceType == 'normal' && !notNumericMT && !isSmartSpace"> {{ !isEnquiry ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck((roomPriceVat * parseInt(meetingLength) / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck((roomPriceVat * parseInt(meetingLength) / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}" v-if="chosenPriceType == 'normal' && !notNumericMT && isSmartSpace"> {{ !isEnquiry ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck(roomPriceVat.toFixed(2).replace('.', ',')) : enquiryPriceCheck(roomPriceVat.toFixed(2)) }}</h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}" v-if="chosenPriceType == 'halfday' && !notNumericMT"> {{ !isEnquiry ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck((roomHalfDay / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck((roomHalfDay / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}"  v-if="chosenPriceType == 'fullday' && !notNumericMT"> {{ !isEnquiry ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck((roomFullDay / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck((roomFullDay / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}" v-if="chosenPriceType == 'opera'"> {{ !isEnquiry ? currencySymbol : '' }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck((roomPriceVat / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck((roomPriceVat / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}" v-if="(chosenPriceType == 'none') || (notNumericMT && chosenPriceType != 'opera')">{{ strings.enquiry }}</h3>
            <h4 class="radio__audience">{{ strings.forselectedduration }}</h4>
            <button 
                v-if="isBE && (available == 1 && exceed == 'no' && valid_layout) " 
                href="" :data-id="id" 
                class="button button--success button--full tabs__button book-now" 
                @click.stop.prevent="create($event)"
                :class="{'button--disabled': isOutsideBusinessHours || isClosed}"
                :disabled="isOutsideBusinessHours || isClosed"
                >
                {{ isInstantBooking? strings.book :strings.sendRequest}}
            </button>
            <div v-if="available == 0 || exceed == 'yes' || !valid_layout">
                <!-- Tiny image carousel full screen carousel on click -->
                <ul class="checklist" v-if="!isSmartSpace">
                    <li class="checklist__item-disabled--attention" v-if="exceed == 'yes'">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/> {{ strings.yourattendees}} ({{ this.$store.state.delegates }}) {{ strings.exceedthelimit }} {{ strings.thisroom }} ({{ roomMin}} - {{roomMax}})
                     </li>
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="available == 0 && exceed == 'no'">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/>{{ strings.roomnotavailable }}
                    </li>
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="!valid_layout && exceed == 'no' && available == 0">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/>{{ strings.thisRoomDoesNotHave }}
                    </li>
                </ul>
            </div>
            <div v-if="isSmartSpace && available == 0">
                 <ul class="checklist" >
                    <li class="checklist__item-disabled--attention">
                        <img class="attentionImage" src="https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/attention-icon.svg"/> {{ strings.yourattendees}} ({{ this.$store.state.delegates }}) {{ strings.exceedthelimit }} {{ strings.thisroom }} ({{ roomMin}})
                     </li>
                </ul>
            </div>
        </div>
        <div class="radio__pricing" v-else>
            <button 
                v-if="isBE && (available == 1 && exceed == 'no' && valid_layout) " 
                href="" :data-id="id"  
                class="button button--success button--full tabs__button book-now" 
                @click.stop.prevent="create($event)" 
                :class="{'button--disabled': isOutsideBusinessHours || isClosed}"
                :disabled="isOutsideBusinessHours || isClosed"
                >{{ isInstantBooking? strings.book :strings.sendRequest}}</button>
            <h3 class="radio__price" v-if="isSmartSpace == true && currentTab == 'package'"> {{ currencySymbol }} {{$store.state.selectedLang === 'de' ? roomPackagePrice.replace('.', ',') : roomPackagePrice}} </h3>
            <h4 class="radio__audience"  v-if="isSmartSpace == true && currentTab == 'package'">{{ strings.forselectedduration }}</h4>
            <p class="ribbon" v-if="priceType == 'smart_space' && chosenPriceType != 'none' && !notNumericMT && demand == 'H'">High demand day</p>
            <p class="ribbon" v-if="priceType == 'smart_space' && chosenPriceType != 'none' && !notNumericMT && demand == 'L'">Low demand day</p>
        </div>

        </div>

        <!-- Details -->

        <div class="radio__details js-radio-details" :class="{ 'radio__details--hidden' : isHidden}">

          <!-- Seating -->

          <div class="radio__single-detail seating-order-block" v-if="!isBE">
              <h4>{{ strings.seatingorder }}</h4>
              <!-- Seating layout in room -->
              <ul class="seating-list" v-if="currentTab == 'room'">
                  <li class="seating-list__item" @click="chooseLayout(403, roomLayout.cocktail)" :class="{'seating-list__item--not-available' : roomLayout.cocktail == null || isExceeded(roomLayout.cocktail), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['cocktail']}" >
                      <img src="../assets/img/seating-cocktail.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cocktail')}">{{ roomLayoutOriginal.cocktail != null ? roomLayoutOriginal.cocktail : '-' }}</p>
                        <p v-if="isCapacityReduced('cocktail')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cocktail != null ? roomLayout.cocktail : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(405, roomLayout.ushape)" :class="{'seating-list__item--not-available' : roomLayout.ushape == null || isExceeded(roomLayout.ushape), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['ushape']}" >
                      <img src="../assets/img/seating-ushape.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('ushape')}">{{ roomLayoutOriginal.ushape != null ? roomLayoutOriginal.ushape : '-' }}</p>
                        <p v-if="isCapacityReduced('ushape')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.ushape != null ? roomLayout.ushape : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(400, roomLayout.boardroom)" :class="{'seating-list__item--not-available' : roomLayout.boardroom == null || isExceeded(roomLayout.boardroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['boardroom']}" >
                      <img src="../assets/img/seating-boardroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('boardroom')}">{{ roomLayoutOriginal.boardroom != null ? roomLayoutOriginal.boardroom : '-' }}</p>
                        <p v-if="isCapacityReduced('boardroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.boardroom != null ? roomLayout.boardroom : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(404, roomLayout.theater)" :class="{'seating-list__item--not-available' : roomLayout.theater == null || isExceeded(roomLayout.theater), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['theater']}" >
                      <img src="../assets/img/seating-theater.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('theater')}">{{ roomLayoutOriginal.theater != null ? roomLayoutOriginal.theater : '-' }}</p>
                        <p v-if="isCapacityReduced('theater')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.theater != null ? roomLayout.theater : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(402,roomLayout.classroom)" :class="{'seating-list__item--not-available' : roomLayout.classroom == null || isExceeded(roomLayout.classroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['classroom']}" >
                      <img src="../assets/img/seating-classroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('classroom')}">{{ roomLayoutOriginal.classroom != null ? roomLayoutOriginal.classroom : '-' }}</p>
                        <p v-if="isCapacityReduced('classroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.classroom != null ? roomLayout.classroom : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(399, roomLayout.banquet)" :class="{'seating-list__item--not-available' : roomLayout.banquet == null || isExceeded(roomLayout.banquet), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['banquet']}" >
                      <img src="../assets/img/seating-banquet.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('banquet')}">{{ roomLayoutOriginal.banquet != null ? roomLayoutOriginal.banquet : '-' }}</p>
                        <p v-if="isCapacityReduced('banquet')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.banquet != null ? roomLayout.banquet : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(401,roomLayout.cabaret)" :class="{'seating-list__item--not-available' : roomLayout.cabaret == null || isExceeded(roomLayout.cabaret), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['cabaret']}" >
                      <img src="../assets/img/seating-cabaret.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cabaret')}">{{ roomLayoutOriginal.cabaret != null ? roomLayoutOriginal.cabaret : '-' }}</p>
                        <p v-if="isCapacityReduced('cabaret')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cabaret != null ? roomLayout.cabaret : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(760,roomLayout.island)" :class="{'seating-list__item--not-available' : roomLayout.island == null || isExceeded(roomLayout.island), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['island']}" >
                      <img src="../assets/img/seating-island.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('island')}">{{ roomLayoutOriginal.island != null ? roomLayoutOriginal.island : '-' }}</p>
                        <p v-if="isCapacityReduced('island')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.island != null ? roomLayout.island : '-' }}</p>
                      </div>
                  </li>
              </ul>
              <!-- Seating layout in room in package -->
              <ul class="seating-list" v-else>
                  <li class="seating-list__item" @click="chooseLayout(403, roomLayout.cocktail)" :class="{'seating-list__item--not-available' : roomLayout.cocktail == null || isExceeded(roomLayout.cocktail), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['cocktail']}" >
                      <img src="../assets/img/seating-cocktail.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cocktail')}">{{ roomLayoutOriginal.cocktail != null ? roomLayoutOriginal.cocktail : '-' }}</p>
                        <p v-if="isCapacityReduced('cocktail')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cocktail != null ? roomLayout.cocktail : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(405, roomLayout.ushape)" :class="{'seating-list__item--not-available' : roomLayout.ushape == null || isExceeded(roomLayout.ushape), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['ushape']}" >
                      <img src="../assets/img/seating-ushape.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('ushape')}">{{ roomLayoutOriginal.ushape != null ? roomLayoutOriginal.ushape : '-' }}</p>
                        <p v-if="isCapacityReduced('ushape')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.ushape != null ? roomLayout.ushape : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(400, roomLayout.boardroom)" :class="{'seating-list__item--not-available' : roomLayout.boardroom == null || isExceeded(roomLayout.boardroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['boardroom']}" >
                      <img src="../assets/img/seating-boardroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('boardroom')}">{{ roomLayoutOriginal.boardroom != null ? roomLayoutOriginal.boardroom : '-' }}</p>
                        <p v-if="isCapacityReduced('boardroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.boardroom != null ? roomLayout.boardroom : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(404, roomLayout.theater)" :class="{'seating-list__item--not-available' : roomLayout.theater == null || isExceeded(roomLayout.theater), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['theater']}" >
                      <img src="../assets/img/seating-theater.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('theater')}">{{ roomLayoutOriginal.theater != null ? roomLayoutOriginal.theater : '-' }}</p>
                        <p v-if="isCapacityReduced('theater')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.theater != null ? roomLayout.theater : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(402, roomLayout.classroom )" :class="{'seating-list__item--not-available' : roomLayout.classroom == null || isExceeded(roomLayout.classroom), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['classroom']}" >
                      <img src="../assets/img/seating-classroom.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('classroom')}">{{ roomLayoutOriginal.classroom != null ? roomLayoutOriginal.classroom : '-' }}</p>
                        <p v-if="isCapacityReduced('classroom')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.classroom != null ? roomLayout.classroom : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(399, roomLayout.banquet)" :class="{'seating-list__item--not-available' : roomLayout.banquet == null || isExceeded(roomLayout.banquet), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['banquet']}" >
                      <img src="../assets/img/seating-banquet.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('banquet')}">{{ roomLayoutOriginal.banquet != null ? roomLayoutOriginal.banquet : '-' }}</p>
                        <p v-if="isCapacityReduced('banquet')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.banquet != null ? roomLayout.banquet : '-' }}</p>
                      </div>
                  </li>
                  <li class="seating-list__item" @click="chooseLayout(401, roomLayout.cabaret)" :class="{'seating-list__item--not-available' : roomLayout.cabaret == null || isExceeded(roomLayout.cabaret), 'seating-list__selectedLayout' : this.$store.state.selectedLayoutinPackage == this.$store.state.layouts['cabaret']}" >
                      <img src="../assets/img/seating-cabaret.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('cabaret')}">{{ roomLayoutOriginal.cabaret != null ? roomLayoutOriginal.cabaret : '-' }}</p>
                        <p v-if="isCapacityReduced('cabaret')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.cabaret != null ? roomLayout.cabaret : '-' }}</p>
                      </div>
                  </li>
                   <li class="seating-list__item" @click="chooseLayout(760,roomLayout.island)" :class="{'seating-list__item--not-available' : roomLayout.island == null || isExceeded(roomLayout.island), 'seating-list__selectedLayout' : this.$store.state.selectedLayout == this.$store.state.layouts['island']}" >
                      <img src="../assets/img/seating-island.png" alt="">
                      <div class="seating-list-capacity">
                        <p class="seating-list__count" :class="{'seating-list__count-original': isCapacityReduced('island')}">{{ roomLayoutOriginal.island != null ? roomLayoutOriginal.island : '-' }}</p>
                        <p v-if="isCapacityReduced('island')" class="seating-list__count seating-list__count-reduced">{{ roomLayout.island != null ? roomLayout.island : '-' }}</p>
                      </div>
                  </li>
              </ul>
          </div>

        <!-- Description -->

        <p class="small radio__single-detail roomDescription" v-html="roomDescriptionTranslated"></p>

        <!-- This room fits {count} people with {type} seating
            This room does not offer {type} seating
         -->

        <!-- Dimensions -->

        <div class="radio__single-detail" v-show="roomHasDimension">

            <h4>{{ strings.roomdimensions }}</h4>

            <ul class="ribbon-list">
            <li class="ribbon-list__item" v-show="roomArea > 0">
                <span class="ribbon-list__type">{{ strings.area }}: </span> {{ roomArea > 0 ? roomArea + 'm²' : '- ' }}
            </li>
            <li class="ribbon-list__item" v-show="roomHeight > 0">
                <span class="ribbon-list__type">{{ strings.height }}: </span> {{ roomHeight > 0 ? roomHeight + 'm' : '- ' }}
            </li>
            <li class="ribbon-list__item" v-show="roomWidth > 0">
                <span class="ribbon-list__type">{{ strings.width }}: </span> {{ roomWidth > 0 ? roomWidth + 'm' : '- ' }}
            </li>
            <li class="ribbon-list__item" v-show="roomLength > 0">
                <span class="ribbon-list__type">{{ strings.length }}: </span> {{ roomLength > 0 ? roomLength + 'm' : '- ' }}
            </li>
            </ul>

        </div>

         <tabs :options="{ useUrlFragment: false }">
            <tab :name="strings.equipment" v-if="roomEquipment.length > 0">
               <ul class="checklist">
                    <li v-show="!isOpera || roomEquipment.includes(item)" v-for="(item,key) in roomAllEquipment" class="checklist__item" :class="{'checklist__item--not-available': !roomEquipment.includes(item) }" :key="key">{{ item }}</li>
                </ul>
            </tab>
            <tab :name="strings.equipmentwithfee" v-if="roomEquipmentFee.length > 0">
                <ul class="checklist">
                    <li v-show="!isOpera || roomEquipmentFee.includes(item)" v-for="(item,key) in roomAllEquipment" class="checklist__item" :class="{'checklist__item--not-available': !roomEquipmentFee.includes(item) }" :key="key">{{ item }}</li>
                </ul>
            </tab>
        </tabs>

        <!-- <div class="radio__single-detail" v-if="!isOpera && !isNCH">
            <h4>{{ strings.availablePackages }}</h4>
            <ul class="checklist">
                <li v-for="(item,key) in packages" :key="key" class="checklist__item">{{ item }}</li>
            </ul>
        </div> -->

        </div>

        <!-- Call-to-action -->
        <div v-if="!isBE">
            <div class="button radio__cta radio__cta--selected" v-if="isRoomSelected(id)">{{ strings.selected }}</div>
            <div class="button radio__cta" v-else>{{ strings.select }}</div>
        </div>

    </label>
    <lightbox
         :images="images"
         ref="roomLightbox"
         :showLightBox="false"
         :show-caption="false"
     ></lightbox>
    </div>
</template>

<script>
import Vue from 'vue'
import Lightbox from 'vue-image-lightbox';
import moment from 'moment';
import VueResource from 'vue-resource';
import VTooltip from 'v-tooltip'

import * as hf from '../assets/misc/helperFunctions.js'
import ModalComponent from './ModalComponent';
import * as dataLayer from '../assets/misc/dataLayer.js';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(VTooltip);
Vue.use(VueResource);

export default {
    data() {
        return {
            show360Modal: false,
            isHidden : true,
            images: [],
            roomDescriptionTranslated: this.roomDescription,
            isEnquiry: false
        }
    },
    components: {
      Lightbox,
      ModalComponent
    },
    props: [
        'id',
        'key',
        'title',
        'instantBookable',
        'roomMin',
        'roomMax',
        'roomPriceVat',
        'correctPrice',
        'roomHalfDay',
        'roomFullDay',
        'roomDescription',
        'roomLayout',
        'roomLayoutOriginal',
        'roomHeight',
        'roomWidth',
        'roomLength',
        'roomArea',
        'roomEquipment',
        'roomEquipmentFee',
        'packages',
        'priceType',
        'chosenPriceType',
        'available',
        'exceed',
        'valid_layout',
        'no_layout',
        'image',
        'selected_room',
        'day',
        'isSmartSpace',
        'demand',
        'minRevenue',
        'currentPackage',
        'threeSixtyView',
        'mt_length',
        'position'
        ],
    methods: {
        enquiryPriceCheck(price) 
        {
            if (price === '0.00')
            {
                this.isEnquiry = true;
                return this.$store.state.strings.enquiry;
            }
            return price
        },
        layoutEnabled(layoutName){
            let self = this;
            if(layoutName == 'island' && !this.isNCH){
                return false;
            }

            if(this.isOpera){
                if(this.currentTab == 'room'){
                    let found = this.$store.state.seatingOrderList.find(obj => obj.text.toLowerCase() == layoutName);
                    return typeof(found) !== "undefined"  && found !== null;
                } else {
                    if(this.isMoreThanOneDay){
                        this.eventList.forEach(event_el => {
                            if(parseInt(self.day) == parseInt(event_el.day)){
                                event_el.packages.forEach(package_el => {
                                    if(parseInt(package_el.id) == event_el.selected_package){
                                        let operaSelectedLayoutCode = hf.getLayoutCode(package_el.selected_layout);
                                        return operaSelectedLayoutCode == layoutName;
                                    }
                                });
                            }
                        });
                    } else {
                        let packageList = this.$store.state.packageInfo;
                        let selectedPackage = this.$store.state.selected_package;
                        packageList.forEach(package_el => {
                            if(parseInt(package_el.id) == parseInt(selectedPackage)){
                                let operaSelectedLayoutCode = hf.getLayoutCode(package_el.selected_layout);
                                return operaSelectedLayoutCode == layoutName;
                            }
                        });
                    }
                }
            }
            return this.roomLayout[layoutName] != null  && this.roomLayout[layoutName] > 0;
        },
        translateDurationType(length){
            let duration_type = "other";
            if(length <= 5){
            duration_type = "half-day";
            }else if(length <= 12){
                duration_type = "full-day";
            }
            return duration_type;
        },
        storeProduct(product, venue){
            let isRoomType = product.order_type == 'room';
            product.layout_en = this.$store.state.strings.layouts_en[product.layout];
            if(isRoomType){
                switch(product.chosen_price){
                    case 'halfday':
                        product.total_price = this.roomHalfDay;
                        break;
                    case 'fullday':
                        product.total_price = this.roomHalfDay;
                        break;
                    default:
                        product.total_price = this.roomPriceVat;
                        break;
                }
            }else{
                product.total_price = product.calculated_prices.price_vat;
            }

            let payload = {
                    "id": product.id,
                    "name": product.title,
                    "category": product.category,
                    "brand": this.$store.state.venueInfo.title + ' - ' + this.$store.state.venueInfo.id,
                    "price":  product.total_price,
                    "quantity": isRoomType ? 1: product.delegates,
                    "dimension3": this.$store.state.venueInfo.city,
                    "dimension4": this.$store.state.venueInfo.country_code,
                    "dimension5": this.$store.state.venueInfo.venue_type_en,
                    "dimension6": product.mt_length,
                    "dimension7": this.translateDurationType(product.mt_length),
                    "dimension8": product.layout_en,
                    "dimension9": moment(product.start,'DD-MM-YYYY HH:mm').format("DD/MM/YYYY HH:mm"),
                    "dimension10": moment(product.end,'DD-MM-YYYY HH:mm').format("DD/MM/YYYY HH:mm"),
                    "dimension12": product.isInstantBookable == 1 ? 'instant booking': product.total_price ? 'booking request': "enquiry",
                    "metric1": product.delegates,
                    "metric2": isRoomType ? product.total_price: product.total_price / product.delegates,
                    };

            localStorage.setItem('checkoutProduct', JSON.stringify(payload));
            localStorage.setItem('venueInfo', JSON.stringify(venue));
        },
        openRoomLightBox(index) {
            let allImages;
            this.images = [];
            for (let i=0; i <  this.image.length; i++) {
              allImages = {
                thumb: this.image[i],
                src: this.image[i],
              }
              this.images.push(allImages);
            }

            if(this.image != '') {
                this.$refs.roomLightbox.showImage(index);
            }
        },
        isRoomSelected(roomID){

            let isBE = this.$store.state.isBE;
            if(isBE){
                return false;
            }
            if(this.$store.state.currentTab == 'room'){
                if(this.$store.state.selectedRoom == roomID){
                   this.$store.commit('detailsText', this.isHidden);
                    return true;
                }
            } else {
                if(this.$store.state.selectedRoominPackage == roomID){
                  this.$store.commit('detailsText', this.isHidden);
                  return true;
                }
            }

        },
        setSelectedRoom(roomID, position){
            this.$store.commit('setSelectedPosition', position);
            this.$store.commit('detailsText', this.isHidden);
            if(this.isBE){
                return;
            }

            if(this.$store.state.currentTab == 'room'){
                this.$store.commit('setSelectedRoom', roomID);
                this.$store.commit('setLayoutsInRoom', roomID)
                this.$store.commit('changeSelectedPrice', roomID);
            } else {
                this.$store.commit('setSelectedRoominPackage', roomID);
                this.$store.commit('setLayoutsInRoom', roomID);

            }
        },
        toggleDetails(){
           this.$store.commit('toggleDetailId', '');
           this.isHidden = !this.isHidden;
        },
        chooseLayout(value, status){
            if(this.isBE){
                //return;
            }

            let delegates = '';
            if(this.isMoreThanOneDay){
                let _day = this.day;
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        delegates = event_el.delegates;
                    }
                });
            } else {
                delegates = this.$store.state.delegates;
            }

            if(status !== null && parseInt(status) >= delegates) {
                if(this.$store.state.currentTab == 'room'){
                    this.$store.commit('setSelectedLayout', value);
                    //this.$store.dispatch('sortRoomList');
                } else {
                    this.$store.commit('setSelectedLayoutinPackage', value);
                    //let roomList = this.$store.state.rooms_in_package;
                    //this.$store.dispatch('sortRoomListinPackage', roomList);
                }
            }
        },
        isExceeded(value){
            let delegates = '';
            if(this.isMoreThanOneDay){
                let _day = this.day;
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        delegates = event_el.delegates;
                    }
                });
            } else {
                delegates = this.$store.state.delegates;
            }
            if(parseInt(value) >= parseInt(delegates)){
                return false;
            } else {
                return true;
            }
        },
        create(event){
            const oldCheckOutHosts = ['sjp.cwteasymeetings.com', 'lilly.cwteasymeetings.com', 'interikea.cwteasymeetings.com', 'meetings.leonardohotels.co.uk', 'devere.meetingpackage.com'];
            if (
                oldCheckOutHosts.some(host => host === window.location.host)
            ) {
                this.createBooking(event)
            } else {
                this.createNewBooking(event)
            }
        },
        async createBooking(event) {
            let roomID = event.target.attributes['data-id'].value;
            let _day = this.day;
            let self = this;
            let currentTab = this.currentTab;
            let lang = this.$store.state.selectedLang;
            let selectedProduct;
            if(lang == 'en'){
                lang = '';
            } else {
                lang = '/' + lang;
            }  
            if(currentTab == 'room'){
                let roomList = this.$store.state.roomInfo;
                roomList.forEach(element => {
                if(element.id == roomID){
                        selectedProduct = Object.assign({}, element); 
                        selectedProduct.title = "room - " + element.title;
                        selectedProduct.id = "r" + roomID; 
                        selectedProduct.category = 'room';
                }
                });
            }else{
                let packageList = this.$store.state.packageInfo;
                packageList.forEach(element => {
                if(element.id == this.$store.state.selectedPackage){
                        selectedProduct = Object.assign({}, element); 
                        selectedProduct.title = "package - " + element.title;
                        selectedProduct.id = "n" + this.$store.state.selectedPackage; 
                        selectedProduct.category = 'package';
                }
                });
            }
                   

            let chosenItemText = {};
            if(this.isMoreThanOneDay){
                let _event = {};
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        let start_date = moment(event_el.date, 'DD-MM-YYYY').format("LL");
                        event_el.selected_room = roomID;
                        chosenItemText.event_date = 'Event date: ' + start_date + ' ' + event_el.start_time + ' to ' + event_el.end_time;
                        chosenItemText.delegates = 'Delegates: ' + event_el.delegates;
                        if(currentTab == 'room'){
                            // Loop through all the rooms to get the name of selected package.
                            event_el.finalList.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                    let selectedPrice = 0;
                                    if(self.chosenPriceType == 'halfday'){
                                        selectedPrice = room_el.calculated_prices.halfday_price;
                                    } else if(self.chosenPriceType == 'fullday') {
                                        selectedPrice = room_el.calculated_prices.fullday_price;
                                    } else if(self.chosenPriceType == 'opera') {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    } else {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    }
                                    event_el.selected_room_price = selectedPrice;
                                }
                            });
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayout);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + parseFloat(event_el.selected_room_price) / 100;
                        } else {
                            // Loop through all the packages to get the name of selected package.
                            event_el.packages.forEach(package_el => {
                                if(parseInt(package_el.id) == event_el.selected_package){
                                    event_el.selected_package_name = package_el.title;
                                    event_el.selecled_package_price = package_el.calculated_prices.price_vat;
                                    event_el.package_min = package_el.package_min;
                                }
                            });
                            // Get the name of selected room
                            event_el.room_list_in_package.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                }
                            });
                            chosenItemText.package = 'Package: ' + event_el.selected_package_name;
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayoutinPackage);
                            let tempDelegates = parseInt(event_el.delegates) > parseInt(event_el.package_min) ? parseInt(event_el.delegates) : parseInt(event_el.package_min);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + (parseFloat(event_el.selecled_package_price) / 100) * tempDelegates;
                        }
                        event_el.chosenItemText = chosenItemText;

                        event_el.isChosen = 1;
                        _event = event_el;
                    }
                });
                
                this.$store.commit('setEventList', this.eventList);
                this.$store.commit('pushToFinalEvents', _event);
                this.$store.commit('setTabIndex', parseInt(_day));
            }else {
                let isOpera = this.$store.state.isOpera;
                let startD = this.$store.state.datetime;
                let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                let endD = moment(startD, 'DD-MM-YYYY HH:mm');
                let mt_length = '';
                let currentTab = this.$store.state.currentTab;
                let isEnquiry = this.$store.state.showEnquiryForm;
                let baseUrl = this.$store.state.baseUrl;
    
                if(this.$store.state.meeting_length == 'overnight'){
                    mt_length = 24;
                } else if(this.$store.state.meeting_length == 'twodays'){
                    mt_length = 36;
                } else {
                    mt_length = parseInt(this.$store.state.meeting_length);
                }
    
                endD = endD.add(mt_length, 'hours');
                let operaEndD = endD;
                endD = endD.format('DD-MM-YYYY HH:mm');
                operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');
    
                this.$store.commit('setProcessing', 'yes');
                // Check if this is Opera Venue.
                if(isOpera){
    
                    let roomIF = [];
                    let packageIF = [];
                    let layout = '';
                    let opera_layout_code = '';
                    let layout_code = '';
                    if(currentTab == 'room'){
                        let roomList = this.$store.state.roomInfo;
                        roomList.forEach(element => {
                            if(element.id == roomID){
                                let selectedPrice = 0;
                                let totalPrice = 0;
                                roomIF['name'] = element.title;
                                roomIF['photo'] = element.room_pictures[0];
                                roomIF['code'] = element.code;
                                roomIF['rate_code'] = element.rate_code;
                                if(self.chosenPriceType == 'halfday'){
                                    selectedPrice = element.calculated_prices.halfday_price;
                                    totalPrice = selectedPrice;
                                } else if(self.chosenPriceType == 'fullday') {
                                    selectedPrice = element.calculated_prices.fullday_price;
                                    totalPrice = selectedPrice;
                                } else {
                                    selectedPrice = element.calculated_prices.price_vat;
                                    totalPrice = parseInt(selectedPrice) * mt_length
                                }
                                roomIF['roomPriceOption'] = {
                                    'unit_price' : selectedPrice,
                                    'price_type' : self.chosenPriceType,
                                    'is_opera_room' : element.code ? true : false,
                                    'total_price' : totalPrice
                                };
                            }
                        });
                        layout_code = this.$store.state.selectedLayout;
                        opera_layout_code = hf.MPLayoutToOperaLayout(layout_code, this.$store.state.venueInfo.operaServer),
                        layout = hf.getLayoutName(layout_code);
                        packageIF['name'] = '';
                        packageIF['code'] = '';
                        packageIF['package_rate_code'] = '';
                    } else {
                        let roomList = this.$store.state.rooms_in_package;
                        roomList.forEach(element => {
                        if(element.id == roomID){
                            roomIF['name'] = element.title;
                            roomIF['photo'] = element.room_pictures[0];
                            roomIF['code'] = element.code;
                            roomIF['rate_code'] = '';
                        }
                        layout_code = this.$store.state.selectedLayoutinPackage;
                        opera_layout_code = hf.MPLayoutToOperaLayout(layout_code, this.$store.state.venueInfo.operaServer),
                        layout = hf.getLayoutName(layout_code);
                        });
    
                        let packageList = this.$store.state.packageInfo;
                        packageList.forEach(element => {
                        if(element.id == this.$store.state.selectedPackage){
                            packageIF['name'] = element.title;
                            packageIF['code'] = element.id;
                            packageIF['package_rate_code'] = element.package_rate_code;
                        }
                        });
                    }

                    let type = this.currentTab == 'room' ? 'room' : 'package';
                    
                    this.$store.dispatch('goToOperaCheckout', {
                        'type' : type,
                        'startD' : startD,
                        'endD' : endD,
                        'operaStartD' : operaStartD,
                        'operaEndD' : operaEndD,
                        'room' : roomIF['name'],
                        'room_id' : roomID,
                        'room_code' : roomIF['code'],
                        'room_price_option' : roomIF['roomPriceOption'],
                        'layout_name' : layout,
                        'layout_code' : layout_code,
                        'opera_layout_code' : opera_layout_code,
                        'room_rate_code' : roomIF['rate_code'],
                        'package' : packageIF['name'],
                        'package_code' : packageIF['code'],
                        'package_rate_code' : packageIF['package_rate_code'],
                        'isInstantBookable': this.instantBookable
                    });
        
                    return;
                }
    
            let ajaxUrl = baseUrl + '/apiv2/create/cart';
            

            let sentData = {};
            sentData.accepted_gdpr = this._accepted_gdpr;
            sentData.start = startD;
            sentData.end = endD;
            sentData.delegates = this.$store.state.delegates;
            sentData.isInstantBookable = this.instantBookable;
            sentData.order_type = currentTab;
            sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
            sentData.user_agent = window.navigator.userAgent;
            sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
            sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
            var bookingType = 'room';
            var bookingRoom = 'room';
            if(currentTab == 'room'){
                bookingRoom = roomID;
                sentData.room = roomID;
                sentData.layout = this.$store.state.selectedLayout;
                sentData.package_id = 'none';
                sentData.currency = this.$store.state.venueInfo.currency_code;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.language = lang;

                // Room price
                this.$store.commit('setSelectedRoom', roomID);
                this.$store.commit('changeSelectedPrice', roomID);
                this.$cookie.set('room_booking_type', this.$store.state.roomBookingType);
                let flag = this.$store.state.totalPriceIndicator;
                let roomPrice = this.$store.state.price;
                let totalPrice = '';
                if(flag == 'usual'){
                    if(mt_length == 24 || mt_length == 36){
                        totalPrice = 0;
                    } else {
                        totalPrice = roomPrice;
                    }
                }
                sentData.room_price = roomPrice;
                sentData.room_price_total = totalPrice;
                let product = {...sentData, ...selectedProduct };
                product.mt_length = mt_length;
                this.storeProduct(product,  this.$store.state.venueInfo);
                if(this.useNewCheckoutPage){
                    if(this.chosenPriceType == 'normal'){
                        totalPrice = parseFloat(roomPrice *  parseInt(mt_length)).toFixed(2);
                    }else{
                        totalPrice = parseFloat(roomPrice).toFixed(2);
                    }
                    sentData.chosenPriceType = this.chosenPriceType;
                    sentData.room_price_total = totalPrice;
                    this.$store.dispatch('goToCheckout', sentData);
                    return;
                }
                Vue.http.post(ajaxUrl, sentData).then(response => {
                    let data = response.body;
                    let url = baseUrl + lang + '/checkout/' + data;

                    // If booking.com here we set some cookies for the thank you page.
                    let site_url = window.location.host;
                    if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com' ){
                        let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                        let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                        let latlon = this.$store.state.venueInfo.latlon.split(',');
                        let latitude = latlon[0];
                        let longitude = latlon[1];
                        this.$cookie.set('bk_check_in_date', check_in_date);
                        this.$cookie.set('bk_check_out_date', check_out_date);
                        this.$cookie.set('bk_latitude', latitude);
                        this.$cookie.set('bk_longitude', longitude);
                    }

                    // Go to checkout page.
                        if(
                            window.location.host == 'sjp.cwteasymeetings.com' || 
                            window.location.host == 'lilly.cwteasymeetings.com' ||
                            window.location.host == 'interikea.cwteasymeetings.com'
                        ){
                            this.$store.dispatch('goToCheckout', sentData);
                        } else {
                            window.location.href = url;
                        }

                    }, response => {
                });
            } else {
                // Package booking.
                bookingType = 'package';
                bookingRoom = roomID;

                sentData.room = roomID;
                sentData.layout = this.$store.state.selectedLayoutinPackage;
                sentData.package_id = this.$store.state.selectedPackage;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.language = lang;
                let product = {...sentData, ...selectedProduct };
                product.mt_length = mt_length;
                this.storeProduct(product,  this.$store.state.venueInfo);
                if(this.useNewCheckoutPage){
                        this.$store.commit('showCheckOutPage', 'yes');
                    this.$store.dispatch('goToCheckout', sentData);
                    return;
                }
                    Vue.http.post(ajaxUrl, sentData).then(response => {
                        let data = response.body;
                        let url = '';
    
                        url = baseUrl + lang + '/checkout/' + data;
    
                        // If booking.com here we set some cookies for the thank you page.
                        let site_url = window.location.host;
                        if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
                            let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                            let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                            let latlon = this.$store.state.venueInfo.latlon.split(',');
                            let latitude = latlon[0];
                            let longitude = latlon[1];
                            this.$cookie.set('bk_check_in_date', check_in_date);
                            this.$cookie.set('bk_check_out_date', check_out_date);
                            this.$cookie.set('bk_latitude', latitude);
                            this.$cookie.set('bk_longitude', longitude);
                        }
    
                        // Go to checkout page.
                        if(
                            window.location.host == 'sjp.cwteasymeetings.com' || 
                            window.location.host == 'lilly.cwteasymeetings.com' ||
                            window.location.host == 'interikea.cwteasymeetings.com'
                        ){
                            this.$store.dispatch('goToCheckout', sentData);
                        } else {
                            window.location.href = url;
                        }
    
                        }, response => {
                    });
                }
            }
        },
        async createNewBooking(event) {
            let roomID = event.target.attributes['data-id'].value;
            let _day = this.day;
            let self = this;
            let currentTab = this.currentTab;
            let lang = this.$store.state.selectedLang;
            let selectedProduct;
            if(lang == 'en'){
                lang = '';
            } else {
                lang = '/' + lang;
            }

            // Impression
            if(currentTab == 'room'){
                let roomList = this.$store.state.roomInfo;
                roomList.forEach(element => {
                    if(element.id == roomID){
                            selectedProduct = Object.assign({}, element); 
                            selectedProduct.title = "room - " + element.title;
                            selectedProduct.id = "r" + roomID; 
                            selectedProduct.category = 'room';
                    }
                });
            } else {
                let packageList = this.$store.state.packageInfo;
                packageList.forEach(element => {
                    if(element.id == this.$store.state.selectedPackage){
                            selectedProduct = Object.assign({}, element); 
                            selectedProduct.title = "package - " + element.title;
                            selectedProduct.id = "n" + this.$store.state.selectedPackage; 
                            selectedProduct.category = 'package';
                    }
                });
            }
                   
            // End Impression
            let chosenItemText = {};
            if(this.isMoreThanOneDay){
                let _event = {};
                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        let start_date = moment(event_el.date, 'DD-MM-YYYY').format("LL");
                        event_el.selected_room = roomID;
                        chosenItemText.event_date = 'Event date: ' + start_date + ' ' + event_el.start_time + ' to ' + event_el.end_time;
                        chosenItemText.delegates = 'Delegates: ' + event_el.delegates;
                        if(currentTab == 'room'){
                            // Loop through all the rooms to get the name of selected package.
                            event_el.finalList.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                    let selectedPrice = 0;
                                    if(self.chosenPriceType == 'halfday'){
                                        selectedPrice = room_el.calculated_prices.halfday_price;
                                    } else if(self.chosenPriceType == 'fullday') {
                                        selectedPrice = room_el.calculated_prices.fullday_price;
                                    } else if(self.chosenPriceType == 'opera') {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    } else {
                                        selectedPrice = room_el.calculated_prices.price_vat * parseInt(self.meetingLength);
                                    }
                                    event_el.selected_room_price = selectedPrice;
                                }
                            });
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayout);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + parseFloat(event_el.selected_room_price) / 100;
                        } else {
                            // Loop through all the packages to get the name of selected package.
                            event_el.packages.forEach(package_el => {
                                if(parseInt(package_el.id) == event_el.selected_package){
                                    event_el.selected_package_name = package_el.title;
                                    event_el.selecled_package_price = package_el.calculated_prices.price_vat;
                                    event_el.package_min = package_el.package_min;
                                }
                            });
                            // Get the name of selected room
                            event_el.room_list_in_package.forEach(room_el => {
                                if(parseInt(room_el.id) == parseInt(event_el.selected_room)){
                                    event_el.selected_room_name = room_el.title;
                                }
                            });
                            chosenItemText.package = 'Package: ' + event_el.selected_package_name;
                            chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                            chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayoutinPackage);
                            let tempDelegates = parseInt(event_el.delegates) > parseInt(event_el.package_min) ? parseInt(event_el.delegates) : parseInt(event_el.package_min);
                            chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + (parseFloat(event_el.selecled_package_price) / 100) * tempDelegates;
                        }
                        event_el.chosenItemText = chosenItemText;

                        event_el.isChosen = 1;
                        _event = event_el;
                    }
                });
                
                this.$store.commit('setEventList', this.eventList);
                this.$store.commit('pushToFinalEvents', _event);
                this.$store.commit('setTabIndex', parseInt(_day));
            }else {
                let isOpera = this.$store.state.isOpera;
                let startD = this.$store.state.datetime;
                let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                let endD = moment(startD, 'DD-MM-YYYY HH:mm');
                let mt_length = '';
                let currentTab = this.$store.state.currentTab;
                let isEnquiry = this.$store.state.showEnquiryForm;
                let baseUrl = this.$store.state.baseUrl;

                if(this.$store.state.meeting_length == 'overnight'){
                    mt_length = 24;
                } else if(this.$store.state.meeting_length == 'twodays'){
                    mt_length = 36;
                } else {
                    mt_length = parseInt(this.$store.state.meeting_length);
                }

                endD = endD.add(mt_length, 'hours');
                let operaEndD = endD;
                endD = endD.format('DD-MM-YYYY HH:mm');
                operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');

                this.$store.commit('setProcessing', 'yes');
    
                let ajaxUrl = baseUrl + '/apiv2/create/cart2';
            
                let sentData = {};
                sentData.language = this.selectedLang;
                sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
                sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
                sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
                sentData.user_agent = window.navigator.userAgent;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.venue_name = this.$store.state.venueInfo.title;
                //sentData.venue_pictures = this.$store.state.venueInfo.venue_pictures;
                sentData.discount_code = this.$store.state.discount_code;
                sentData.venue_type_en = this.$store.state.venueInfo.venue_type_en;
                sentData.country_code = this.$store.state.venueInfo.country_code;
                sentData.city = this.$store.state.venueInfo.city;
                sentData.terms_of_use = this.$store.state.venueInfo.terms_of_use;
                sentData.delegates = this.$store.state.delegates;
                sentData.order_type = currentTab;

                sentData.events = [
                    {
                        'start' : startD,
                        'end' : endD,
                        'currency' : this.$store.state.venueInfo.currency_code,
                        'room' : {}
                    }
                ];
                let availability_id = '';
                if(currentTab == 'room'){
                    let selectedRoomInfo = this.$store.state.roomInfo.find(
                        obj => obj.id == roomID
                    )
                    availability_id = selectedRoomInfo.availability_id;

                    if(selectedRoomInfo.adjusted_meeting_length){
                        mt_length = selectedRoomInfo.adjusted_meeting_length;
                        endD = moment(startD, 'DD-MM-YYYY HH:mm');
                        endD = endD.add(mt_length, 'hours');
                        endD = endD.format('DD-MM-YYYY HH:mm');
                        sentData.events[0]['end'] = endD;
                    }
                    // Room price
                    this.$store.commit('setSelectedRoom', roomID);
                    this.$store.commit('changeSelectedPrice', roomID);
                    this.$cookie.set('room_booking_type', this.$store.state.roomBookingType);
                    let flag = this.$store.state.totalPriceIndicator;
                    let roomPrice = this.$store.state.price;
                    
                    let totalPrice = '';
                    if(flag == 'usual'){
                        if(mt_length == 24 || mt_length == 36){
                            totalPrice = 0;
                        } else {
                            totalPrice = roomPrice;
                        }
                    } else {
                        totalPrice = roomPrice;
                    }

                    sentData.events[0].room.id = roomID;
                    sentData.events[0].room.name = selectedRoomInfo.title;
                    sentData.events[0].room.layout_code = this.$store.state.selectedLayout;
                    sentData.events[0].package = {};
                    sentData.events[0].room.total_price = totalPrice * 100;
                    sentData.events[0].room.price_type = selectedRoomInfo.calculated_prices.type;

                    sentData.events[0].room.type = this.chosenPriceType == 'normal' ? 'hourly' : this.chosenPriceType;
                    sentData.events[0].room.isInstantBookable = this.isInstantBooking;

                    let product = {...sentData, ...selectedProduct };
                    product.mt_length = mt_length;
                    this.storeProduct(product,  this.$store.state.venueInfo);

                    if(this.useNewCheckoutPage){
                        if(this.chosenPriceType == 'normal'){
                            totalPrice = parseFloat(roomPrice *  parseInt(mt_length)).toFixed(2);
                        }else{
                            totalPrice = parseFloat(roomPrice).toFixed(2);
                        }
                        sentData.chosenPriceType = this.chosenPriceType;
                        sentData.room_price_total = totalPrice;
                        this.$store.dispatch('goToCheckout', sentData);
                        return;
                    }

                } else {
                    // Package booking.
                    let selectedPackageInfo = this.$store.state.packageInfo.find(
                        obj => obj.id == this.$store.state.selectedPackage
                    )
                    let selectedRoominPackageInfo = this.$store.state.rooms_in_package.find(
                        obj => obj.id == roomID
                    )
                    availability_id = selectedRoominPackageInfo.availability_id;

                    if(selectedRoominPackageInfo.adjusted_meeting_length){
                        mt_length = selectedRoominPackageInfo.adjusted_meeting_length;
                        endD = moment(startD, 'DD-MM-YYYY HH:mm');
                        endD = endD.add(mt_length, 'hours');
                        endD = endD.format('DD-MM-YYYY HH:mm');
                        sentData.events[0]['end'] = endD;
                    }
                    let correctDelegates =
                        parseInt(this.$store.state.delegates) < parseInt(selectedPackageInfo.package_min)
                        ? parseInt(selectedPackageInfo.package_min)
                        : parseInt(this.$store.state.delegates)
                    let packagePrice = this.$store.state.price;

                    sentData.events[0].room.id = roomID;
                    sentData.events[0].room.name = selectedRoominPackageInfo.title;
                    sentData.events[0].room.layout_code = this.$store.state.selectedLayoutinPackage;
                    sentData.events[0].room.isInstantBookable = this.isInstantBooking;
                    sentData.events[0].package = {
                        'id' : this.$store.state.selectedPackage,
                        'name' : selectedPackageInfo.title,
                        'rate_code' : selectedPackageInfo.package_rate_code,
                        'package_min': parseInt(selectedPackageInfo.package_min),
                        'total_price': selectedPackageInfo.calculated_prices.price_vat * correctDelegates,
                        'unit_price': selectedPackageInfo.calculated_prices.price_vat,
                        'price_type': selectedPackageInfo.calculated_prices.type,
                        'includes': selectedPackageInfo.services, 
                    };

                    let product = {...sentData, ...selectedProduct };
                    product.mt_length = mt_length;
                    this.storeProduct(product,  this.$store.state.venueInfo);
                    if(this.useNewCheckoutPage){
                        this.$store.commit('showCheckOutPage', 'yes');
                        this.$store.dispatch('goToCheckout', sentData);
                        return;
                    }
                }
                sentData.availability_id = availability_id;
                Vue.http.post(ajaxUrl, sentData).then(response => {
                    let data = response.body;
                    let url = baseUrl + lang + '/book-universal/' + data;
                    if(this.isRadisson){
                        url = baseUrl + '/book-universal/' + data;
                    }
                    // If booking.com here we set some cookies for the thank you page.
                    let site_url = window.location.host;
                    if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com' ){
                        let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                        let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                        let latlon = this.$store.state.venueInfo.latlon.split(',');
                        let latitude = latlon[0];
                        let longitude = latlon[1];
                        this.$cookie.set('bk_check_in_date', check_in_date);
                        this.$cookie.set('bk_check_out_date', check_out_date);
                        this.$cookie.set('bk_latitude', latitude);
                        this.$cookie.set('bk_longitude', longitude);
                    }

                    // Go to checkout page.
                        if(
                            window.location.host == 'sjp.cwteasymeetings.com' || 
                            window.location.host == 'lilly.cwteasymeetings.com' ||
                            window.location.host == 'interikea.cwteasymeetings.com'
                        ){
                            this.$store.dispatch('goToCheckout', sentData);
                        } else {
                            window.location.href = url;
                        }

                    }, response => {
                });
            }
        },
        isCapacityReduced(layout) {
            return parseInt(this.roomLayoutOriginal[layout]) > parseInt(this.roomLayout[layout])
        },
    },
    computed: {
      isDavinci() {
        return window.isDavinci
      },
      showEstimatedLocalPrice() {
        if (this.isDavinci && this.$store.state.venueInfo.local_currency_code && (this.$store.state.venueInfo.currency_code !== this.$store.state.venueInfo.local_currency_code)) {
            return true
        }
        return false
      },
        roomPriceOriginal(){
            if(this.correctPrice && this.correctPrice.original_price){
                return this.correctPrice.original_price;
            }else{
                return 0;
            }
        },
        showDetailsToggle(){
            return (this.$store.state.layouts && this.$store.state.layouts.length > 0) ||  (this.roomDescriptionTranslated) || this.roomHasDimension || this.roomEquipment.length > 0 || this.roomEquipmentFee.length > 0;
        },
        displayDiscountAmount(){
            let discountedPercentage = 0;
            let difference = 0;
            let quantity = this.chosenPriceType == 'normal' ? this.meetingLength: 1;
            switch(this.chosenPriceType){
                case "normal":
                    difference = (this.roomPriceOriginal * this.meetingLength) - (this.roomPriceVat * this.meetingLength);
                    break;
                case "halfday":
                     difference = this.roomPriceOriginal - this.roomHalfDay;
                    break;
                case "fullday":
                    difference = this.roomPriceOriginal - this.roomFullDay;
                    break;
                case "opera":
                    difference = this.roomPriceOriginal - this.roomPriceVat;
                    break;
            }
            return (difference / (this.roomPriceOriginal * quantity) * 100 ).toFixed(0) + "% " + this.$store.state.strings.savings;
        },
        isRadisson(){
            return window.isRadisson == '1' ? true : false
        },
        hasReducedPrice(){
            let priceIsDiscounted = false;
            if(window.location.hostname === 'interikea.cwteasymeetings.com'){
                return priceIsDiscounted;
            }
            switch(this.chosenPriceType){
                case "normal":        
                    priceIsDiscounted = this.roomPriceOriginal > this.roomPriceVat;
                    break;
                case "halfday":
                     priceIsDiscounted = this.roomPriceOriginal > this.roomHalfDay;
                    break;
                case "fullday":
                    priceIsDiscounted = this.roomPriceOriginal > this.roomFullDay;
                    break;
                case "opera":
                    priceIsDiscounted = this.roomPriceOriginal > this.roomPriceVat;
                    break;
            }
            return priceIsDiscounted;
        },
        isInstantBooking(){
            return this.instantBookable == '1' && !(this.available == 0 || this.exceed == 'yes' || !this.valid_layout)
        },
        roomHasDimension(){
            return this.roomArea > 0 || this.roomHeight > 0 || this.roomWidth > 0 || this.roomLength > 0
        },
        isClosed(){
            return this.$store.state.isClosed;
        },
        isOutsideBusinessHours(){
            return this.$store.state.isOutsideBusinessHours;
        },
        eventList() {
            return this.$store.state.eventList;
        },
        isMoreThanOneDay() {
            return this.$store.state.isMoreThanOneDay;
        },
        isBE(){
            return this.$store.state.isBE;
        },
        useNewCheckoutPage(){
            return this.$store.state.useNewCheckoutPage;
        },
        isNCH(){
            return this.$store.state.isNCH;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        isHanselWL() {
            return this.$store.state.isHanselWL;
        },
        currencySymbol(){
            return this.$store.state.currencySymbol;
        },

        roomPackagePrice(){    
            let delegates = this.$store.state.delegates > parseInt(this.roomMin) ? this.$store.state.delegates: parseInt(this.roomMin);
            return  parseFloat(this.roomPriceVat * delegates).toFixed(2);
        },
        currentTab() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.roomDescription, lang: this.$store.state.selectedLang }).then((data)=>{
                this.roomDescriptionTranslated = data;
                });
            } else {
                this.roomDescriptionTranslated = this.roomDescription;
            }
            return this.$store.state.currentTab;
        },
        notNumericMT() {
            if (this.isOpera){
                return false;
            }
            let mt_length = this.$store.state.meeting_length;
            if(mt_length == 'overnight' || mt_length == 'twodays'){
                return true;
            } else {
                return false;
            }
        },
        activeTranslate() {
            return this.$store.state.isTranslated;
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        toggleDetail() {
          return this.$store.state.toggleDetailId;
        },
        strings () {
  	        return this.$store.state.strings
        },
        checkImage() {
            if(this.image == '') {
                return true;
            }
            else {
                return false
            }
        },
        meetingLength() {
            if(this.isMoreThanOneDay){
                return this.mt_length;
            } else {
                return this.$store.state.meeting_length;
            }
        },
        roomAllEquipment() {
            return this.$store.state.allEquipment
        }
    },
    watch: {
        toggleDetail() {
          if(this.id == this.$store.state.toggleDetailId) {
              this.isHidden = !this.isHidden;
              this.$store.commit('toggleDetailId', '');
          }
        },
        activeTranslate() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.roomDescription, lang: this.$store.state.selectedLang }).then((data)=>{
                this.roomDescriptionTranslated = data;
                });
            } else {
                this.roomDescriptionTranslated = this.roomDescription;
            }
        },
        selectedLang() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.roomDescription, lang: this.$store.state.selectedLang }).then((data)=>{
                this.roomDescriptionTranslated = data;
                });
            } else {
                this.roomDescriptionTranslated = this.roomDescription;
            }
        }
    }
}
</script>

<style scoped>
.radio__item.isBE {
    background: #fff;
    margin: 20px 0 20px 0;
}

button {
    outline: none;
}
button.book-now {
    width: 70%;
    border: none;
    padding: 18px;
    text-transform: uppercase!important;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
}

.no-border-bottom {
    border-bottom: none;
}

.new_seating_order{
    display: none;
}

.radio_head__be {
    flex: 0 3 70% !important;
}
.radio_head__be ul, .radio__single-detail ul{
   padding-left: 0px;
}
.radio__title{
    margin-top:0px;
}
.isBE .new_seating_order ul {
    flex-wrap: wrap !important;
}

.isBE .new_seating_order ul li {
    flex: none !important;
    margin-bottom: 5px !important;
}

.isBE .radio__content {
    border-left: none !important;
    cursor: inherit !important;
}

.isBE .radio__content:after, .isBE .radio__content:before {
    content: none !important;
}

.radio .isBE input[type=radio]:checked+.radio__content {
    background-color: white;
    box-shadow: inset 0 0 0 1px #e0e0e0;
}
.radio_head_disabled{
    flex: 0 1 70%!important;
 }
 .radio__pricing_disabled .radio__price, .radio__pricing_disabled .radio__audience, .radio__pricing_disabled .ribbon, .radio__pricing_disabled .radio__audience, .radio__pricing_disabled  .radio__audience, .radio_head_disabled, .new_seating_order_disabled{
     opacity: 0.4;
 }
 .radio__pricing_disabled .checklist__item--attention, .roomitemList .checklist__item--attention{
     background:none;
     padding:0px;
 }
 .attentionImage{
    border: none;
    width: 15px;
    height: 15px;
    vertical-align: bottom;
 }
@media (min-width: 639px){
    .isBE .radio__carousel {
        width: 400px;
        height: 200px;
        cursor: pointer;
    }

    .new_seating_order{
        display: block;
        width: 32%;
        max-width: 300px;
    }

}
.isBE .radio_head_disabled{
    flex: 0 3 70%!important;
}

.isBE .new_seating_order .seating-list__item.seating-list__item--not-available {
    display: none;
}

@media(max-width:638px){
    .ribbon {
        display: block;
    }
    button.book-now{
        width: 100%;
    }
}
</style>

<style>
  .video__container_360 iframe {
    width: 100%!important;
    position: inherit!important;
    top: 0px!important;
    height: 100%!important;
  }
   .video__container_360 .modal-body  {
    margin: 0px!important;
    height: 400px!important;
  }
   .video__container_360{
    height: 100%;
  }
  .video__container_360 .modal-container{
    width: 800px;
    height:485px!important;
  }
  @media screen and (max-width: 830px) {
    .video__container_360 .modal-container{
      width: 100%!important;
    }
  }
   .video__container_360 .modal-body  {
     margin: 0px!important;
    height: 400px!important;
  }
  .video__container_360{
    height: 100%;
  }
  .video__container_360 .vue-lb-button-close{
    top:10px!important;
    margin-bottom: 0px!important;
  }
  .video__container_360 .modal-container{
    width: 800px;
    height:485px!important;
  }

  .video__container_360 .modal-wrapper, .video__container_360 .modal-body{
      height:100%!important;
  }
  .video__container_360 .modal-body{
      margin-top: 0px!important;
      padding: 0px!important;
      margin-bottom: 15px!important;
  }
  .video__container_360 .modal-container{
    height: 550px!important;
    width: 800px!important;
    padding:0px!important   
  }
 .video__container_360 .modal-header{
        display:none!important;
  }
   .video__container_360 .modal-footer{
        border-top: none!important;
  }
  .threesixtyLink{
    display: block!important;
    margin-bottom: 0px;
    cursor: pointer;
    color: #333;
    text-decoration-color: rgb(51, 122, 183);
    margin-top: 5px!important;
  }
  .threesixtyLink::hover{
    color: rgb(51, 122, 183);
  }
  .video__container_360 .modal-body iframe {
    width: 100%!important;
    height: 550px!important;
      }
  .video360ModalBody{
    height:100%!important;
  }
  .video__container_360 .modal-container{
      background:transparent!important;
  }
  .isNCH .threeSixtyCloseBtn{
      background-color: #00aa50!important;
  }
  .isNCH .radio__main .no-border-bottom{

  }
  .isNCH .radio__pricing .radio__audience{
          font-size: 12px;
  }
    @media screen and (max-width: 830px) {
    .video__container_360 .modal-container{
      width: 400px!important;
      max-width: 400px!important;
    }
  }
   @media screen and (min-width: 1200px) {
    .isNCH .new_seating_order{
      width: 35%!important;
      max-width: 300px;
    }
  }
  .is_seasonal{
      /* color: #7ED321!important; */
      font-weight: 400;
  }
  .original_price{
      color: #333 !important;
      font-weight: 400;
      text-decoration: line-through;
      margin-bottom:0px!important;
  }
  .original_price svg{
    padding-top: 3px;
    padding-bottom: 2px;
    color: black;
    font-weight: 400;
  }
  .savings{
    text-decoration: none;
    font-size: 12px;
    /* color: #7ED321 !important; */
    margin-bottom: 5px;
    font-size: 12px!important;
    font-weight: 400;
  }
  .seating-list-capacity {
    display: flex;
    justify-content: center;
  }
  .seating-list-capacity .seating-list__count-original {
    text-decoration: line-through;
  }
  .seating-list-capacity .seating-list__count-reduced {
    color: darkred;
    margin-left: 5px;
  }
</style>